export default __webpack_public_path__ + "static/media/rent_banner.d253a4d2.png";